import { mapEnumToOptions } from '@abp/ng.core';

export enum NetworkType {
  Corporate = 1,
  VPN = 2,
}

export const networkTypeOptions = mapEnumToOptions(NetworkType);
